export const RoomType = {
  Macao: 'red',
  Vegas: 'green',
  Monaco: 'blue',
};
